import { createSlice } from "@reduxjs/toolkit";
import addSuperadminDetailsApi from "@custom/rtk-apis/masterSuperAdminProfile/addSuperadminDetail";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const addSuperadminDetailsSlice = createSlice({
  name: "addSuperadminDetailsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addSuperadminDetailsApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(addSuperadminDetailsApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(addSuperadminDetailsApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default addSuperadminDetailsSlice.reducer;
